Page auctionPage
	needsAuth = true

	// Style
	Border	subBoxBorder = {2px solid #e8e8e8}

	// Input fields
	float	directBid = -1
	float	agentLimit = -1
	float	counterOffer

	// UI State
	bool	showBids
	string	auctionEndLocal = ""
	float	reviewCurrentPrice = float.notANumber
	string	startAuctionError = ""

	// Cancellation
	bool	showCancellationOverlay
	string	cancellationRequestText = ""
	string	cancellationRequestError = ""

	// Data
	Good	good
	Field[]	fields
	Action[]	actions
	Message	popupMessage

	show: string id
		try
			good = await app.goods.subscribeById id
			if good.state == Draft and good.seller == app.user.id then app.navigateTo editPage id; return
			if not Platform.isDebug then await app.actions.add {actionType:ViewAuction, good:id, user:app.user.id}

			html.setTitle "{good.Marke} {good.Modell} - 123womo"
			fields = app.fields.filter.showInAuctionPageTable and .showOnEditPage and .showFor.includes(good.Typ)
			fields.sortBy.viewOrder
			if app.user?.userType == Admin
				actions = await app.actions.subscribe "good = '{good.id}'" expand:"user"
			else
				actions = await app.actions.subscribe "good = '{good.id}'"
			counterOffer = int.notANumber
			showCancellationOverlay = false
			cancellationRequestText = ""
			cancellationRequestError = ""
			auctionEndLocal = ""
			showImageOverlay = false
			let setLimitAction = getSetLimitAction
			agentLimit = setLimitAction ? setLimitAction.amount : good.currentPrice + app.minimumBidIncrease

			if good.state == Review and app.user.userType == Admin
				reviewCurrentPrice = good.Preisvorstellung * .75
		
		catch
			app.navigateTo homePage

	hide
		if good?.id then app.goods.unsubscribe good.id
		app.actions.unsubscribe
	
	tick
		if good and (good.state == Auction or good.state == Negotiation) then refresh

	onMessagesChanged
		if not good then return
		let lastMessage = getCurrentRoundMessages.findLast.good == good.id
			if lastMessage.showPopup and not lastMessage.read
				popupMessage = lastMessage
			else
				popupMessage = null
	
	Action[] getCurrentRoundActions
		if not actions then return []
		if not good?.auctionStartTime then return actions
		float startTime = Date(good.auctionStartTime).time
		return actions.filter Date(.created).time >= startTime

	Message[] getCurrentRoundMessages
		if not good?.auctionStartTime then return app.messages.items
		float startTime = Date(good.auctionStartTime).time
		return app.messages.items.filter Date(.created).time >= startTime
	
	getSetLimitAction => (getCurrentRoundActions.sortByDescending.created).find.actionType == SetAgentLimit and .good == good.id

	draw
		if not good then return
		if showImageOverlay then	drawImageOverlay
		if popupMessage then	drawPopup
		if showCancellationOverlay then	drawCancellationOverlay
		drawContent


	drawPopup
		if not popupMessage then return
		overlay onClickOutside:closePopup
			column backgroundColor:white, padding:32, width:640, minHeight:480, fontFamily:"OpenSans", fontSize:18, position:relative
			alignItems:center, justifyContent:center, borderRadius:style.boxBorderRadius, boxShadow:style.boxShadow, gap:32
				
				// Close button
				div position:absolute, top:-12, right:-12, width:32, height:32, borderRadius:16, backgroundColor:primaryColor
				cursor:pointer, display:flex, alignItems:center, justifyContent:center, onClick:closePopup
					div "✕", color:white, fontSize:12, fontWeight:bold
				
				column alignItems:center, gap:4, maxHeight:400, overflowY:auto, overflowX:hidden, padding:{top:16}
					div "{popupMessage.created.dayShortMonthNameString} {popupMessage.created.hourMinuteString} Uhr", fontSize:13, color:lightGray
					if popupMessage.subject then div text:popupMessage.subject, fontSize:15, fontWeight:bold, color:secondaryColor
					div popupMessage.text, textAlign:center, padding:{top:8}
	
	closePopup
		if popupMessage then await app.messages.update popupMessage, {read:true}
		popupMessage = null
		refresh

	drawCancellationOverlay
		if not showCancellationOverlay then return
		overlay
			column backgroundColor:white, padding:32, width:400, minHeight:200, fontFamily:"OpenSans", fontSize:18, position:relative
			alignItems:center, justifyContent:center, borderRadius:style.boxBorderRadius, boxShadow:style.boxShadow, gap:32

				div text:"Storno anfragen", fontSize:18, fontWeight:bold, color:#2b3145
				form.text label:"Was ist passiert?", model:cancellationRequestText, rows:10
				if cancellationRequestError
					div text:cancellationRequestError, fontSize:12, color:#ef4444
				app.button "Abschicken", width:100%, isDisabled:cancellationRequestText.trim.length < 10
					onClick:
						cancellationRequestError = ""
						refresh
						string text = cancellationRequestText.trim
						if text.trim.length < 10
							cancellationRequestError = "Bitte beschreiben Sie kurz, was passiert ist."
							refresh
							return
						try
							await backend.post "/api/cancellation-request", {goodId:good.id, text}
							if app.user.id == good.seller then	good.cancellationRequestBySeller = text; else 
							if app.user.id == good.buyer then	good.cancellationRequestByBuyer = text
							cancellationRequestText = ""
							showCancellationOverlay = false
							refresh
						catch as error
							cancellationRequestError = "Stornierung konnte nicht gesendet werden."
							print type:Error "Error sending cancellation request:", error
							refresh
		onClickOutside:
			showCancellationOverlay = false
			cancellationRequestError = ""
			refresh

	drawSubHeader
		div display:flex, justifyContent:center, padding:{top:28 bottom:28}
			div width:100%, display:flex, alignItems:center, gap:12, cursor:pointer, onClick:app.navigateTo buyPage
				div text:"◀", fontSize:20, color:#808080
				div text:"Zurück zu den Suchergebnissen", fontSize:16, color:#40465a

	drawContent
		grid gap:20 gridTemplate:"'img main' 'info info' / 1fr 360px" mobileGridTemplate:"'img' 'main' 'info'" marginTop:32px
			div gridArea:'img' display:flex, flexDirection:column, gap:16, minWidth:0
				drawGallery good.Bilder

			div gridArea:'main' flex:1, backgroundColor:#ffffff, borderRadius:style.boxBorderRadius, padding:{top:32 bottom:32 left:32 right:32}, boxShadow:style.boxShadow, display:flex, flexDirection:column
				app.drawGoodState good
				if good.test then div text:"Nicht öffentliche Test-Auktion.", fontSize:12
				div text:"{good.Marke} {good.Modell}", fontSize:24, fontWeight:bold, color:#2b3145
				if good.state == Auction and (app.user?.userType == Business or app.user?.userType == Admin)
					drawAuction
				else
				if good.state == Review and app.user.userType == Admin
					drawReviewForAdmin
				else
				if good.state == Review and app.user.id == good.seller
					drawReviewForSeller
				else
				if app.user.id == good.seller or app.user.id == good.buyer
					switch good.state
						Negotiation:	drawNegotiation
						NotSold:	drawNotSold
						Sold:	drawSold
						PickedUp:	drawSold
						default:	drawLastMessage
				else
				if good.state == Sold and app.user.userType == Admin
					drawLastMessage
				else
					drawState

			column gridArea:'info' minWidth:0 gap:16
				if app.user?.userType == Admin then drawHistory
				drawInfo
				drawFooter

	drawGallery: string[] images, bool showMainImage = true, float imageHeight = 72
		state int currentIndex = 0
		state int galleryId = math.randomFloat

		// Main image
		if showMainImage
			div width:isMobile ? 460 : 540, height:isMobile ? 345 : 405, backgroundColor:#f0f0f0, borderRadius:style.boxBorderRadius, position:relative, overflow:hidden, display:flex, alignItems:center, justifyContent:center
				if images.length > 0
					img "{backend.url}/api/files/goods/{good.id}/{images[currentIndex]}", width:100%, cursor:pointer
						onClick:
							openImageOverlay images, currentIndex
				else
					img Placeholder, width:100%, height:100%, objectFit:cover

				// Prev and next buttons
				if images.length > 1
					img Prev, position:absolute, left:10, width:60px, cursor:pointer
						onClick: currentIndex = (currentIndex - 1) mod images.length; refresh; scrollThumbnailIntoView galleryId

					img Next, position:absolute, right:10, width:60px, cursor:pointer
						onClick: currentIndex = (currentIndex + 1) mod images.length; refresh; scrollThumbnailIntoView galleryId

		// Thumbnails in a horizontal scrollable container
		if images.length > (showMainImage ? 1 : 0)
			div width:100%, height:(showMainImage ? 80 : imageHeight + 8), position:relative, display:flex, alignItems:center
				let containerElement = div width:100%, display:flex, gap:8, overflowX:auto, padding:{bottom:4}, scrollBehavior:"smooth"
					for images as image
						let imgElement = img "{backend.url}/api/files/goods/{good.id}/{image}", height:imageHeight, width:auto, maxWidth:imageHeight*2, objectFit:contain
							border:{width:4, style:solid, color:i == currentIndex ? primaryColor : "transparent"}
							cursor:pointer, borderRadius:12px
							id: i == currentIndex ? "selected-in-{galleryId}" : "not-selected"
							onClick:
								currentIndex = i
								if showMainImage
									refresh
									scrollThumbnailIntoView galleryId
								else
									openImageOverlay images, i

				// Show prev and next buttons if the thumbnails are scrollable
				if containerElement.scrollWidth > containerElement.clientWidth
					img Prev, position:absolute, left:6, top:26, width:28px, cursor:pointer
						onClick: currentIndex = (currentIndex - 1) mod images.length; refresh; scrollThumbnailIntoView galleryId
					img Next, position:absolute, right:6, top:26, width:28px, cursor:pointer
						onClick: currentIndex = (currentIndex + 1) mod images.length; refresh; scrollThumbnailIntoView galleryId

	openImageOverlay: string[] images, int index
		overlayImages = images
		overlayImageIndex = index
		showImageOverlay = true
		refresh

	// After clicking a thumbnail or arrow in the gallery, make sure the current image is visible and centered in the thumbnail strip.
	scrollThumbnailIntoView: int galleryId
		let currentImageElement = html.getElementById("selected-in-{galleryId}")
		if(!currentImageElement) return;
		let containerElement = currentImageElement.parentNode
		let left = currentImageElement.offsetLeft - containerElement.offsetLeft;
		let targetLeft = left + currentImageElement.offsetWidth / 2 - containerElement.clientWidth / 2;
		containerElement.scrollTo({left:targetLeft, behavior:"smooth"});

	// Overlay
	bool	showImageOverlay
	int	overlayImageIndex = 0
	string[]	overlayImages

	drawImageOverlay
		if not showImageOverlay or overlayImages.length == 0 then return
		overlay
			div width:100%, height:100%, backgroundColor:"rgba(0,0,0,0.9)", display:flex, alignItems:center, justifyContent:center, position:relative
				img Close position:absolute, top:8, right:8, width:80px, cursor:pointer
					onClick:
						showImageOverlay = false
						refresh

				img "{backend.url}/api/files/goods/{good.id}/{overlayImages[overlayImageIndex]}", maxWidth:"90%", maxHeight:"90%", objectFit:contain

				if overlayImages.length > 1
					img Prev, position:absolute, left:20, width:80px, cursor:pointer
						onClick: overlayImageIndex = (overlayImageIndex - 1) mod overlayImages.length; refresh

					img Next, position:absolute, right:20, width:80px, cursor:pointer
						onClick: overlayImageIndex = (overlayImageIndex + 1) mod overlayImages.length; refresh

	drawAuction
		if not good then return
		let bids = getCurrentRoundActions.filter.actionType == DirectBid or .actionType == AutomaticBid
		float currentPrice = good.currentPrice
		let minBid = currentPrice + app.minimumBidIncrease

		column gap:24
			bool isRunning = app.drawCountdown good
			if not isRunning then return
			if bids and bids.length > 0
				div color:lightGray, marginBottom:showBids ? 0 : -16
					let text = bids.length == 1 ? "Es wurde ein Gebot abgegeben" : "Es wurden {bids.length} Gebote abgegeben"
					div text, textDecoration:underline, marginBottom:4, cursor:pointer, onClick:showBids = !showBids; refresh
					if showBids
						grid gridTemplateColumns:"1fr 1fr" gap:4
							for bids as bid
								div "{bid.created.dayShortMonthNameString} {bid.created.hourMinuteString} Uhr"
								div text:(bid.actionType == "AutomaticBid" ? "✨ " : "") + bid.amount.currencyString, textAlign:right			
				
			div display:flex, gap:16, flexWrap:wrap
				drawPrice "Aktueller Preis", currentPrice ? currentPrice.currencyString : "Kein Gebot"
				drawPrice "Preisvorstellung", good.Preisvorstellung ? good.Preisvorstellung.currencyString : "keine"
				drawPrice "Provision", currentPrice ? ((currentPrice * good.commissionRate) atLeast good.commissionMin).currencyString : "keine"

			let message = getCurrentRoundMessages.findLast.good == good.id and .context == Auction
				drawNegotiationBox message.subject, message.text

			// grid gridTemplateColumns:[1 1], gap:16
			// 	form.number model:directBid, unit:"€", onInput: refresh
			// 	app.button "Bieten", isDisabled:directBid < minBid or good.state != Auction or good.seller == app.user.id
			// 		onClick:
			// 			await backend.post "/api/bid", {goodId:good.id, actionType:"DirectBid", amount:directBid}
			// 			refresh

			column border:subBoxBorder, borderRadius:8, padding:{top:16 bottom:16 left:16 right:16}, gap:16
				div text:"Mein Bietagent", fontSize:16, fontWeight:bold, color:#2b3145
				let setLimitAction = getSetLimitAction
				if setLimitAction and message and (message.kind == AutoBidToBecomeHighest or message.kind == AutoBidToStayHighest or message.kind == SavedLimitWhileAlreadyHighest)
					div text:"Bietagent aktiv mit einem Limit von {setLimitAction.amount.currencyString}", fontSize:14, color:secondaryColor
				div "Ihr Bietagent wird jedes Gebot automatisch um {app.minimumBidIncrease} € überbieten bis ihr Limit erreicht ist.", fontSize:13
				row gap:8
					div flex:1
						form.number model:agentLimit, unit:"€", onInput: refresh, width:100%
					app.button "-", width:50px, padding:{top:12 bottom:12 left:20 right:20}, isDisabled:agentLimit - app.minimumBidIncrease < minBid, onClick:agentLimit = agentLimit - app.minimumBidIncrease; refresh
					app.button "+", width:50px, padding:{top:12 bottom:12 left:20 right:20}, onClick:agentLimit = agentLimit + app.minimumBidIncrease; refresh
				app.button text:"Bietagenten speichern", width:100%, isDisabled:agentLimit < minBid or good.state != Auction or good.seller == app.user.id
					onClick:
						if agentLimit < minBid
							alert("Ihr Limit muss mindestens {minBid.currencyString} betragen, damit der Bietagent aktiv wird. Bitte prüfen Sie Ihre Eingabe und geben Sie ein höheres Limit ein.")
							return
						if agentLimit >= currentPrice*8 and currentPrice >= 10000
							alert("{agentLimit.currencyString} ist rund das {math.round(agentLimit / currentPrice)}-fache des aktuellen Preises. Bitte prüfen Sie Ihre Eingabe und geben Sie ein geringeres Limit ein.")
							return
						let result = await backend.post "/api/bid", {goodId:good.id, actionType:"SetAgentLimit", amount:agentLimit}
						System.log "SetAgentLimit result:", result
						// if result.status == "AuctionNotActive" then Platform.reload
						refresh

	drawNegotiation
		if not app.user then return
		let messages = getCurrentRoundMessages.filter.good == good.id and .context == Negotiation
		messages.sortBy.created
		column gap:24
			div app.goodStateNames[good.state], fontSize:13, color:lightGray
			bool isRunning = app.drawCountdown good
			if not isRunning then return
			for messages[-2..]
				drawNegotiationBox .subject, .text, .price
				if .kind == ReceivedOfferFromBuyer or .kind == ReceivedOfferFromSeller
					string offerMessageId = .id
					div display:flex, gap:12
						app.button "Annehmen", width:100%
							onClick:
								await backend.post "/api/negotiate/accept", {goodId:good.id, messageId:offerMessageId}
								refresh
						if app.enableOfferRejection and isNegotiationOfferRejectable messages, .
							app.button "Ablehnen", width:100%
								onClick:
									await backend.post "/api/negotiate/reject", {goodId:good.id, messageId:offerMessageId}
									refresh

			if messages.any.kind == ReceivedOfferFromBuyer or .kind == ReceivedOfferFromSeller or .kind == ReceivedRejectFromBuyer or .kind == ReceivedRejectFromSeller
				// Counter offer
				let highestOfferFromBuyer = (messages.withMax.price filter:.kind == SendCounterOfferToSeller or .kind == ReceivedOfferFromBuyer)?.price or good.currentPrice
				let lowestOfferFromSeller = (messages.withMin.price filter:.kind == SendCounterOfferToBuyer  or .kind == ReceivedOfferFromSeller)?.price or good.Preisvorstellung
				if highestOfferFromBuyer < lowestOfferFromSeller
					column border:subBoxBorder, borderRadius:8, padding:{top:16 bottom:16 left:16 right:16}, gap:16
						div text:"Gegenangebot", fontSize:18, fontWeight:bold, color:#2b3145
						form.number model:counterOffer, unit:"€", onInput: refresh
						bool isValid = counterOffer.isValidNumber
						if counterOffer.isValidNumber and not(highestOfferFromBuyer <= counterOffer <= lowestOfferFromSeller)
							isValid = false
							div "Ihr Gegenangebot muss zwischen {highestOfferFromBuyer.currencyString} und {lowestOfferFromSeller.currencyString} liegen.", fontSize:12, color:#ef4444

						app.button "Gegenangebot abgeben", width:100%, isDisabled:not isValid
							onClick:
								float amount = counterOffer
								counterOffer = float.notANumber
								refresh
								await backend.post "/api/negotiate/counter-offer", {goodId:good.id, amount}
								refresh

			if good.seller == app.user.id and messages.last?.kind == SendRejectToBuyer or messages.last?.kind == ReceivedRejectFromBuyer
				drawReactivateBox

	bool isNegotiationOfferRejectable: Message[] messages, Message offer
		if offer.kind != ReceivedOfferFromBuyer and offer.kind != ReceivedOfferFromSeller then return false
		for messages backwards as message
			if message.id == offer.id then return true
			if message.kind == ReceivedOfferFromBuyer or message.kind == ReceivedOfferFromSeller or message.kind == SendCounterOfferToBuyer or message.kind == SendCounterOfferToSeller or message.kind == SendRejectToBuyer or message.kind == SendRejectToSeller
				return false
		return false

	drawNegotiationBox: string title, string text, float price = 0, bool isSecondary = false
		div border:subBoxBorder, borderRadius:12, padding:{top:14 bottom:14 left:16 right:16}
			backgroundColor:isSecondary ? style.veryLightGray : white
			column gap:8
				div text:title, fontSize:18, fontWeight:bold, color:#2b3145
				if price > 0
					div text: price.currencyString, fontSize:28, fontWeight:bold, color:secondaryColor
				div text, fontSize:14, color:#2b3145

	drawReviewForAdmin
		if not app.user or app.user.userType != Admin then return
		if not good then return

		if not auctionEndLocal
			float serverNow = Time.now + app.serverTimeOffset
			if not good.test
				float nextFullHour = math.ceil(serverNow / 3600000) * 3600000
				Date dt = Date.fromTime(nextFullHour + 48 hours)
				if dt.hour < 10
					dt = Date.fromValues dt.year, dt.month, dt.day, 10, 0
				else if dt.hour > 16
					Date nextDay = dt + 24 hours
					dt = Date.fromValues nextDay.year, nextDay.month, nextDay.day, 10, 0
				auctionEndLocal = "{dt.dayMonthYearString} {dt.twoDigitHour}:{dt.twoDigitMinute} Uhr"
			else
				Date dt = Date.fromTime(serverNow + 1 minutes)
				auctionEndLocal = "{dt.dayMonthYearString} {dt.twoDigitHour}:{dt.twoDigitMinute} Uhr"

		column gap:16
			div app.goodStateNames[good.state], fontSize:13, color:lightGray
			column border:subBoxBorder, borderRadius:8, padding:{top:16 bottom:16 left:16 right:16}, gap:16
				drawPrice "Preisvorstellung", good.Preisvorstellung ? good.Preisvorstellung.currencyString : "keine"
				form.text label:"Auktionsende", model:auctionEndLocal
					help:"Format: 31.12.2025 23:59 Uhr (lokale Zeit)"
				form.number label:"Startpreis", model:reviewCurrentPrice, unit:"€", onInput: refresh
				if good.test
					div text:"Diese Test-Auktion wird nur auf qa.123womo.de angezeigt und es wird keine 'Neue Auktion gestartet' Benachrichtigung gesendet."
				if startAuctionError
					div text:startAuctionError, fontSize:12, color:#ef4444
				app.button "Bearbeiten", width:100%, isDisabled:good.state != Review, onClick:app.navigateTo editPage good.id
				app.button "Auktion starten", width:100%, isDisabled:good.state != Review
					onClick:
						startAuctionError = ""
						refresh
						try
							string s = auctionEndLocal.trim
							if s.endsWith(" Uhr")	then s = s[..-4]
							else if s.endsWith("Uhr")	then s = s[..-3]
							s = s.trim
							string[] parts = s.split(" ")
							if parts.length < 2
								startAuctionError = "Bitte geben Sie Datum und Uhrzeit an."
								refresh
								return
							string[] d = parts[0].split(".")
							string[] t = parts[1].split(":")
							if d.length < 3 or t.length < 2
								startAuctionError = "Ungültiges Format. Beispiel: 31.12.2025 23:59 Uhr"
								refresh
								return
							int day = cast d[0]
							int month = cast d[1]
							int year = cast d[2]
							int hour = cast t[0]
							int minute = cast t[1]
							Date utc = Date.fromValues year, month, day, hour, minute
							await backend.post "/api/start-auction", {goodId:good.id, auctionEndTime:utc.utcString, currentPrice:reviewCurrentPrice}
							refresh
						catch as error
							startAuctionError = "Auktion konnte nicht gestartet werden."
							print type:Error "Error starting auction:", error
							refresh

	drawSold
		drawLastMessage
		TimeString pickupDate = app.user.id == good.seller ? good.pickupDateBySeller : good.pickupDateByBuyer
		if not pickupDate
			column border:subBoxBorder, borderRadius:8, padding:{top:16 bottom:16 left:16 right:16}, margin:{top:16px}, gap:16
				app.button "{good.Typ} wurde abgeholt", width:100%
					onClick:
						try
							await backend.post "/api/pickup", {goodId:good.id}
							refresh
						catch as error
							print type:Error "Error picking up good:", error
							refresh
							
				string hasRequest = app.user.id == good.seller ? good.cancellationRequestBySeller : good.cancellationRequestByBuyer
				if hasRequest
					div text:"Stornierung wurde angefragt", fontSize:14, color:lightGray, textAlign:center
				else
					app.button "Storno anfragen", width:100%
						onClick:
							showCancellationOverlay = true
							cancellationRequestText = ""
							cancellationRequestError = ""
							refresh

	drawNotSold
		if not app.user then return
		drawLastMessage
		if app.user.id == good.seller then drawReactivateBox

	drawReactivateBox
		// Change asking price and restart auction
		column border:subBoxBorder, borderRadius:8, padding:{top:16 bottom:16 left:16 right:16}, margin:{top:16px}, gap:16
			div text:"Inserat erneut aktivieren", fontSize:18, fontWeight:bold, color:#2b3145
			form.number label:"Preisvorstellung anpassen", model:good.Preisvorstellung, unit:"€", onInput: refresh
			app.button "Erneut aktivieren", width:100%, isDisabled: not good.Preisvorstellung.isValidNumber or good.Preisvorstellung <= 0
				onClick:
					await backend.post "/api/ready-for-review", {goodId:good.id, Preisvorstellung:good.Preisvorstellung}
					refresh

	drawLastMessage
		if not app.user then return
		column gap:24
			div app.goodStateNames[good.state], fontSize:13, color:lightGray
			let message = getCurrentRoundMessages.findLast.good == good.id
				drawNegotiationBox message.subject, message.text, message.price

	drawReviewForSeller
		if not app.user then return
		column gap:24
			div app.goodStateNames[good.state], fontSize:13, color:lightGray
			let message = app.messages.items.findLast.good == good.id
				drawNegotiationBox message.subject, message.text, message.price
			app.button "Bilder hinzufügen", width:100%, onClick:app.navigateTo editPage good.id

	drawState
		if not app.user then return
		column gap:24
			div app.goodStateNames[good.state], fontSize:13, color:lightGray

	drawPrice: string label, string value
		div display:flex, flexDirection:column
			if label then div text:label, fontSize:14, color:#7a8195
			div text:value, fontSize:20, fontWeight:bold, color:secondaryColor

	drawHistory
		if not actions then return
		actions.sortByDescending.created
		app.box
			div fontSize:35, marginBottom:16, text:"Verlauf für Administratoren"
			grid gridTemplateColumns:"140px 85px 1fr 220px 80px 20px" gap:4 alignItems:center
				for actions as action
					let marginTop = action.actionType == ReadyForReview or action.actionType == AuctionEndedBelowAskingPrice ? 24px : 0px
					div action.created ? "{action.created.dayShortMonthNameString} {action.created.hourMinuteString} Uhr" : "", margin:{top:marginTop}
					div action.user == "" ? "System" : action.user == good.seller ? "Verkäufer" : action.user == good.buyer ? "Käufer" : "", margin:{top:marginTop}
					div action.expand?.user?.name or "", margin:{top:marginTop}
					div app.actionTypeNames[action.actionType], fontSize:12, margin:{top:marginTop}
					div action.amount ? action.amount.currencyString : "", textAlign:right, margin:{top:marginTop}
					div "📃", fontSize:12, cursor:pointer, margin:{top:marginTop}, onClick:Platform.redirect "{backend.url}/_/#/collections?collection=actions&record={action.id}"
				div good.created ? "{good.created.dayShortMonthNameString} {good.created.hourMinuteString} Uhr" : ""
				div ""
				div ""
				div "Erstellt", fontSize:12
				div ""
				div ""

	drawInfo
		column gap:style.gapBetweenBoxes width:100%
			fields.eachDistinct.section as section, items
				app.box
					div fontSize:35, marginBottom:16, text:section
					switch section
						"Beschreibung"
							div good[items.first.fieldName].replaceAll("\n", "<br>")
						"Ausstattung"
							row flexWrap:wrap, gap:8
								for items
									if good[.fieldName]
										div text:.name backgroundColor:primaryColor, color:white, padding:{5 12}, borderRadius:16, fontSize:12
						default
							div columnCount:isMobile ? 1 : 2, gap:style.gapBetweenBoxes
								for items
									row marginBottom:8px gap:16px
										let name = .name
										if name == "readyForPickupTime" then name = .description
										div text:name width:190px
										string valueString = good[.fieldName]
										if .dataType == "toggle" then	valueString = valueString ? "Ja" : "Nein"
										if .dataType == "date" and valueString then	valueString = Date(valueString).dayMonthYearString
										div "{valueString} {.unit}"
	
				if section == "Zustand" and (good.Bilder_der_Maengel or good.Maengel)
					app.box
						div fontSize:35, marginBottom:16, text:"Mängel"
						div good.Maengel.replaceAll("\n", "<br>"), marginBottom:8px
						div width:100%, display:flex, flexDirection:column
							drawGallery good.Bilder_der_Maengel, showMainImage:false, imageHeight:100

	drawBox: string title, string body
		if not body then return
		app.box
			div fontSize:35, marginBottom:16, text:title
			div text:body, fontSize:14

	drawFooter
		div width:100%, border:{1px solid #e5e9f2}, borderRadius:8, padding:{top:16 bottom:16 left:20 right:20}, display:flex, alignItems:center, gap:16, backgroundColor:#ffffff
			div text:"i", width:24, height:24, borderRadius:12, backgroundColor:"#0098da", color:#ffffff, fontSize:16, fontWeight:bold, display:flex, alignItems:center, justifyContent:center, flexShrink:0
			div fontSize:14, color:#2b3145, fontStyle:italic
				span text:"Alle Inseratsdaten basieren ausschließlich auf Angaben des Verkäufers und können fehlerhaft sein."
